import React from 'react';
import Modal from 'antd/es/modal';
import { classNames } from '../Utils/pureHelpers';
import { CloseIcon } from '../Icons/bp-tags/closeIcon';

function MainModal(props: $TSFixMe) {
  return (
    <Modal
      className={classNames('main-modal', props?.className)}
      width={props?.width}
      visible={props?.visible}
      onCancel={props?.onCancel}
      closable={props?.closable != null ? props?.closable : true}
      destroyOnClose
      footer={null}
      centered
      maskClosable={!!props?.maskClosable}
      closeIcon={<CloseIcon />}
      title={null}>
      <div className='modal-title'>
        {props?.image && <img src={props?.image} alt='modal' />}
        {props?.title && <h2 className='h2'>{props?.title}</h2>}
      </div>
      {props?.children}
    </Modal>
  );
}

export default MainModal;
